module.exports = __webpack_public_path__ + "img/3.bf19f50d.png";